<template>
    <div class="container delivery mt-5">
        <div class="row">
            <div class="block-title">К оплате <span v-if="this.total_old && this.total_old !== this.total" class="sum_no_discount">{{ this.total_old_formatted }}</span> <span class="sum_with_discount">{{ this.total_formatted }}Р</span></div>
        </div>
        <div class="row">
            <div class="inline_objects mt-3">
                <button type="submit" class="btn btn-lg btn-regular btn-bi" :disabled="!this.isSubmitBtnActive"
                        @click.prevent="addOrder()">Оформить заказ</button>
                <div v-if="!this.isSizesSelected" class="danger">Выберите размеры для всех товаров</div>
                <div v-if="!this.isDeliveryMethodSelected" class="danger">Выберите способ доставки</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        addOrder()
        {
            let params = {
                'delivery_method_id': this.$store.state.delivery.selected
            }

            this.$store.dispatch("cart/addOrder", params);
        }
    },
    computed: {
        total() {
            return this.$store.state.cart.total;
        },
        total_old() {
            return this.$store.state.cart.total_old;
        },
        total_formatted() {
            return this.$store.state.cart.total_formatted;
        },
        total_old_formatted() {
            return this.$store.state.cart.total_old_formatted;
        },
        isSizesSelected() {
            return !this.$store.state.cart.items.filter((x) => !x.is_size_selected).length;
        },
        isDeliveryMethodSelected() {
            return !!this.$store.state.delivery.selected;
        },
        isSubmitBtnActive() {
            return this.isSizesSelected && this.isDeliveryMethodSelected;
        }
    },
};
</script>
